import { useLocation } from "react-router-dom";
import PromoBanner from "@/components/PromoBanner";

/**
 * Renders the global promo banner on all public pages.
 * Hidden on /admin and /signer-devis/* to keep workflow UIs clean.
 */
const HIDE_ON = ["/admin", "/signer-devis"];

export const GlobalPromoBanner = () => {
  const { pathname } = useLocation();
  if (HIDE_ON.some((p) => pathname.startsWith(p))) return null;
  return <PromoBanner />;
};

export default GlobalPromoBanner;
